module.exports = __webpack_public_path__ + "img/card_title.9a72f7d6.png";